export default __webpack_public_path__ + "static/media/Newsletter 005.f63b3c5b.png";